// extracted by mini-css-extract-plugin
export default {"pageContent":"M5yO5wJqFG0s_nELuau3","pageLogo":"X89H8t7oRgJyrKzODACS","card":"F1l4_Bi7Gkc75M8EFupn","cardTitle":"VI0iScbq8b4EiBt4FGgD"};